module.exports = __webpack_public_path__ + "static/media/background.8e801875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/background.jpg
// module id = 841
// module chunks = 0